import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { setLoading } from "../../redux/publicReducer/actions";
import { useRouteMatch, useHistory } from "react-router-dom";
import { setOrderSession } from "../../redux/cartReducer/actions";
import { useCookies } from "react-cookie";
import { numberWithCommas } from "../../utils/numbersWithComma";
import Cards from "react-credit-cards";
import "react-credit-cards/es/styles-compiled.css";
import "react-credit-cards/lib/styles.scss";
import Swal from "sweetalert2";
import { Box, Typography, Button, useMediaQuery } from "@material-ui/core";
import {
  CreditCardSharp as CreditCardSharpIcon,
  ArrowBackSharp as ArrowBackSharpIcon,
} from "@material-ui/icons";
import SweetAlert2 from "react-sweetalert2";
import { Backdrop } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";

const tableNumber = sessionStorage.getItem("table");
const apiBaseURL = process.env.REACT_APP_API_BASE_URL;
const serverId = process.env.REACT_APP_SERVER_ID;
const siteId = process.env.REACT_APP_SITE_ID;
const storeId = process.env.REACT_APP_STORE_ID;
const site = process.env.REACT_APP_SITE;
const RestaurantName = process.env.REACT_APP_RESTAURANT_NAME;
const RestaurantAddress = process.env.REACT_APP_RESTAURANT_ADDRESS;
const ZipCode = process.env.REACT_APP_ZIP_CODE;
const enableWorldPay = parseFloat(process.env.REACT_APP_ENABLE_WORLDPAY);
const enableBoldPayment = parseFloat(process.env.REACT_APP_ENABLE_BOLDPAYMENT);
const buttonText = process.env.REACT_APP_BUTTON_TEXT;
const buttonColor = process.env.REACT_APP_BUTTON_COLOR;
const enableSL = parseInt(process.env.REACT_APP_ENABLE_SL);

export const Worldpay = (props) => {
  const {
    totalPriceItems,
    tips,
    cartItems,
    promoCode,
    totalDiscount,
    rewardsBalance,
    giftCardBalance,
    orderSession,
  } = useSelector((state) => state.cart);
  const { orderProcessingDate, selectedAddress, orderProcessingType, user } =
    useSelector((state) => state.public);

  const deliveryCharge = props.location.state.deliveryCharge || 0;
  const transactionFee = props.location.state.transactionFee || 0;
  const serviceCharge = props.location.state.serviceCharge || 0;
  const subTotal = props.location.state.subTotal || 0;
  const tax = props.location.state.tax || 0;
  const discount = props.location.state.discount || 0;
  const total = props.location.state.total;

  if (enableBoldPayment === 1 && enableWorldPay === 0) {
    return (
      <BoldPayment
        user={user}
        selectedAddress={selectedAddress}
        deliveryCharge={deliveryCharge}
        transactionFee={transactionFee}
        serviceCharge={serviceCharge}
        subTotal={subTotal}
        tax={tax}
        discount={discount}
        total={total}
      />
    );
  } else {
    return (
      <WorldPay
        orderProcessingDate={orderProcessingDate}
        orderProcessingType={orderProcessingType}
        cartItems={cartItems}
        selectedAddress={selectedAddress}
        deliveryCharge={deliveryCharge}
        transactionFee={transactionFee}
        serviceCharge={serviceCharge}
        promoCode={promoCode}
        rewardsBalance={rewardsBalance}
        giftCardBalance={giftCardBalance}
        totalPriceItems={totalPriceItems}
        tax={tax}
        tips={tips}
        subTotal={subTotal}
        discount={discount}
        total={total}
        user={user}
      />
    );
  }
};

const WorldPay = ({
  orderProcessingDate,
  orderProcessingType,
  cartItems,
  selectedAddress,
  deliveryCharge,
  transactionFee,
  serviceCharge,
  promoCode,
  rewardsBalance,
  giftCardBalance,
  totalPriceItems,
  tax,
  tips,
  subTotal,
  discount,
  total,
  user,
}) => {
  const history = useHistory();
  const match = useRouteMatch();
  const dispatch = useDispatch();
  const [pid, setPid] = useState("");
  const [orderId, setOrderId] = useState(
    sessionStorage.getItem("order_id") ?? 0
  );
  const [userId, setUserId] = useState("");
  const [cookieOrderId, setCookieOrderId, removeCookieOrderId] = useCookies([
    "",
  ]);
  const [axiosFailed, setAxiosFailed] = useState(false); // State to track axios failure

  const setCookie = (key, value) => {
    const expires = new Date();
    expires.setTime(expires.getTime() + 365 * 24 * 60 * 60 * 1000);
    document.cookie =
      key + "=" + value + ";expires=" + expires.toUTCString() + ";path=/";
  };

  async function initVantivForm(orderId = 0) {
    if (totalPriceItems) {
      const p_url = apiBaseURL + "/payment/initialize/" + siteId;

      let returnURL = site + "/thankyou.php";
      let balance = 0;
      if (rewardsBalance > 0) {
        balance = parseFloat(rewardsBalance);
        returnURL = apiBaseURL + "/rewards/" + orderId + "/partial/" + siteId;
      }

      if (giftCardBalance > 0) {
        balance = parseFloat(giftCardBalance);
        returnURL = apiBaseURL + "/giftcards/" + orderId + "/partial/" + siteId;
      }

      const params = {
        OrderID: "001",
        Total: total - balance,
        Tax: tax,
        ReturnURL: returnURL,
        RestaurantName: RestaurantName,
        RestaurantAddress: RestaurantAddress,
        UserAddress: selectedAddress.address,
        UserCity: selectedAddress.city,
        UserZipCode: selectedAddress.zipCode,
        ZipCode: ZipCode,
      };

      console.log(params, p_url);

      axios
        .post(p_url, params)
        .then((response) => {
          const data = response.data;
          console.log(data, "DATA PID");
          console.log(response);

          setPid(data);
          localStorage.setItem("pid", data);

          if (data != "" && orderId == 0) {
            setCookie("sic_email", selectedAddress.email);
            setCookie("sic_phone", selectedAddress.phone);
            setCookie("sic_name", selectedAddress.first_name);
            setCookie("sic_address", JSON.stringify(selectedAddress));
            const url =
              apiBaseURL +
              "/postpayment/setOrder/" +
              siteId +
              "?server_id=" +
              serverId;
            const d = new Date(orderProcessingDate);
            axios
              .post(url, {
                cartItems: cartItems,
                totalPriceItems: totalPriceItems,
                total: total,
                subTotal: subTotal,
                tips: tips,
                tax: tax,
                deliveryCharge: orderProcessingType == 2 ? deliveryCharge : "0",
                serviceCharge: serviceCharge > 0 ? serviceCharge : "0",
                transactionFee: transactionFee > 0 ? transactionFee : "0",
                promoCode: promoCode,
                pid: data,
                order_id: !!sessionStorage.getItem("order_id")
                  ? sessionStorage.getItem("order_id")
                  : orderId,
                orderProcessingType:
                  orderProcessingType == 0
                    ? "pickup"
                    : orderProcessingType == 1
                      ? "dine-in"
                      : "delivery",
                orderProcessingDate: {
                  date:
                    d.getFullYear() +
                    "/" +
                    (d.getMonth() + 1) +
                    "/" +
                    d.getDate(),
                  time: d.getHours() + ":" + d.getMinutes(),
                },
                selectedAddress: selectedAddress,
                instructions: sessionStorage.getItem("instuctions"),
                serverName:
                  tableNumber && tableNumber != "" && tableNumber != "none"
                    ? "eServer"
                    : "eCommerce",
                tableNumber: tableNumber,
                selectedRevenueCenter: sessionStorage.getItem("revenueCenter"),
              })
              .then((response) => {
                sessionStorage.setItem("order_id", response.data.order_id);
                setCookieOrderId("orderId", response.data.order_id, {
                  path: "/",
                });
                sessionStorage.setItem("user_id", response.data.user_id);
              })
              .catch((error) => {
                console.error(error);
              });
          }

          dispatch(setLoading(false));
        })
        .then(() => {
          // clear items in cart
          localStorage.clear();
          sessionStorage.removeItem("order_id");
          sessionStorage.removeItem("table");
        })
        .catch((err) => {
          console.error(err);
          setAxiosFailed(true); // Set axiosFailed to true if the request fails
        });
    }
  }

  async function setInitOrderSession(paymentType) {
    let paymentMethod = {};
    if (paymentType == "rewards") {
      paymentMethod.type = "Rewards";
      paymentMethod.balance = parseFloat(rewardsBalance);
    } else {
      paymentMethod.type = "Gift Cards";
      paymentMethod.balance = parseFloat(giftCardBalance);
    }

    const payments = [
      {
        "payment-type": paymentMethod.type,
        amount: paymentMethod.balance,
        tip: 0,
      },
      {
        "payment-type": "Credit Card",
        amount: total - rewardsBalance,
        tip: tips,
      },
    ];

    const params = {
      cartItems: cartItems,
      selectedAddress: selectedAddress,
      total: total,
      tips: tips,
      pid: "",
      payments: payments,
      subTotal: subTotal,
      orderProcessingType:
        orderProcessingType == 0
          ? "pickup"
          : orderProcessingType == 1
            ? "dine-in"
            : "delivery",
      orderProcessingDate: orderProcessingDate,
      instructions: sessionStorage.getItem("instuctions"),
      orderId: 0,
    };

    // if (paymentMethod.type == "Rewards") {
    //   return await rewardsService.setSessionOrders(params);
    // } else if (paymentMethod.type == "Gift Cards") {
    //   return await giftcardService.setSessionOrders(params);
    // }
  }

  async function main(paymentType) {
    await setInitOrderSession(paymentType).then((res) => {
      dispatch(setOrderSession(res.data));
      setOrderId(res.data.order_id);
      setUserId(res.data.user_id);
      initVantivForm(res.data.order_id);
    });
  }

  useEffect(() => {
    dispatch(setLoading(true));
    if (rewardsBalance > 0) {
      main("rewards");
    } else if (giftCardBalance > 0) {
      main("giftcards");
    } else {
      initVantivForm();
    }
  }, [totalPriceItems]);

  return (
    <div style={{ marginLeft: "20px" }}>
      <br />
      {pid && !axiosFailed && (
        <iframe
          align="right"
          id="ctl00_MainContent_ifrm"
          src={`https://hc.mercurypay.com/Checkoutiframe.aspx?pid=${pid}`}
          height="600px"
          frameBorder="0"
          style={{ textAlign: "left", overflow: "hidden", width: "100%" }}
        ></iframe>
      )}
    </div>
  );
};

const BoldPayment = ({
  user,
  selectedAddress,
  deliveryCharge,
  transactionFee,
  serviceCharge,
  subTotal,
  tax,
  discount,
  total,
}) => {
  // Custom Form Styles
  const inputStyle = {
    color: "#333",
    fontSize: "16px",
    fontWeight: "normal",
    borderRadius: "12px",
    border: "1px solid",
    boxSizing: "border-box",
    padding: "12px 14px",
    outline: "none",
    width: "100%",
  };
  const checkBoxStyle = {
    height: "24px",
    width: "24px",
    marginRight: "12px",
    backgroundColor: "#000",
    cursor: "pointer",
  };
  const formDivs = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    height: "100px",
    textAlign: "left",
    flexGrow: "1",
  };
  const iconInputStyle = {
    position: "absolute",
    left: "14px",
    top: "14px",
    pointerEvents: "none",
    color: "#909090",
    fontSize: "21px",
  };
  const errorStyle = {
    color: "red",
    fontSize: "12px",
    marginTop: "2px",
  };
  const labelStyle = {
    fontSize: "14px",
    fontWeight: "400",
    marginBottom: "4px",
    textAlign: "left",
  };
  const [containerStyle, setContainerStyle] = useState({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    boxSizing: "border-box",
    margin: 0,
    padding: 0,
  });
  const [expDateInputStyle, setExpDateInputStyle] = useState({ ...inputStyle });
  const [nameInputStyle, setNameInputStyle] = useState({ ...inputStyle });
  const [numberInputStyle, setNumberInputStyle] = useState({
    ...inputStyle,
    paddingLeft: "44px",
  });
  const [cvcInputStyle, setCvcInputStyle] = useState({
    ...inputStyle,
    paddingLeft: "44px",
  });

  const [focus, setFocus] = useState("");
  const [cvc, setCvc] = useState("");
  const [expiry, setExpiry] = useState("");
  const [name, setName] = useState("");
  const [number, setNumber] = useState("");
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [savedCards, setSavedCards] = useState([]);
  const [showSaveCardCheckbox, setShowSaveCardCheckbox] = useState(true);
  const [loading, setLoading] = useState(false);

  const history = useHistory();
  const Swal = require("sweetalert2");
  const customerNumber =
    user?.CustomerNumber || sessionStorage.getItem("customerNumber");

  const orderId = sessionStorage.getItem("order_id") ?? 0;
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  // Check for changes in viewport height and screen size
  useEffect(() => {
    const updateContainerStyle = () => {
      if (isSmallScreen && window.innerHeight < 880) {
        setContainerStyle((prev) => ({
          ...prev,
          height: "",
        }));
      } else {
        setContainerStyle((prev) => ({
          ...prev,
          height: "100vh",
        }));
      }
    };

    // Initial update on mount
    updateContainerStyle();

    // Add resize event listener to update styles on window resize
    window.addEventListener("resize", updateContainerStyle);

    // Cleanup listener on unmount
    return () => {
      window.removeEventListener("resize", updateContainerStyle);
    };
  }, [isSmallScreen]);

  // Initialize site URL based on environment
  useEffect(() => {
    const getSiteUrl = () => {
      if (window.location.hostname === "localhost") {
        return "http://localhost:3000";
      } else {
        return window.location.origin;
      }
    };
  }, []);

  // Save to session storage depending on the user
  useEffect(() => {
    console.log(user, "user from redux");
    if (user) {
      sessionStorage.setItem("customerNumber", user.CustomerNumber);
    }
  }, [user]);

  // Check if there is a saved boldpay data of user
  useEffect(() => {
    const checkForSavedCardInfo = async () => {
      const url = `${apiBaseURL}/payment/save-customer-details`;

      try {
        setLoading(true); // Set loading to true before API call
        const response = await axios.post(url, {
          customerNumber: customerNumber,
          serverId: serverId,
          siteId: siteId,
        });
        const data = response.data;
        console.log(data);

        if (data.existingRecords) {
          setSavedCards(data.existingRecords);
          showCardPrompts(data.existingRecords);
        } else {
          console.log("User does not have a saved credit card");
        }
      } catch (error) {
        handleError(error);
      } finally {
        setLoading(false); // Set loading to false after API call completes
      }
    };

    if (!customerNumber) {
      console.error("No customer number found.");
      setShowSaveCardCheckbox(false);
      return;
    } else {
      checkForSavedCardInfo();
    }
  }, [serverId, siteId, customerNumber, user]);

  // Simple function to enhance code readability and efficiency
  const handleError = (error) => {
    console.log(error);
    console.error(
      error.response
        ? `Error: ${error.response.data}`
        : "Network Error. Please check your connection and the server URL."
    );
  };

  // Show pop-up modal for each saved card
  const showCardPrompts = async (cards) => {
    if (!Array.isArray(cards)) {
      console.error("The 'cards' parameter must be an array:", cards);
      return;
    }

    for (const card of cards) {
      const proceed = await new Promise((resolve) => {
        Swal.fire({
          icon: "question",
          html: `<div id="swal-buttons"></div>`,
          showConfirmButton: false,
          showCancelButton: false,
          allowOutsideClick: false,
          didRender: () => {
            ReactDOM.render(
              <>
                <Typography
                  style={{
                    fontSize: "1.4rem",
                    marginBottom: "2rem",
                  }}
                >
                  Do you want to use your card number ending in{" "}
                  <span style={{ color: "#3085d6" }}>
                    {card.MaskedAccount.slice(-4)}
                  </span>
                  ?
                </Typography>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    columnGap: ".5rem",
                  }}
                >
                  <Button
                    style={{
                      cursor: "pointer",
                      backgroundColor: "#d33",
                      color: "white",
                      border: "none",
                      fontSize: "1.12rem",
                      textTransform: "none",
                      width: "50%",
                    }}
                    onClick={() => {
                      console.log("User chose not to use the saved card.");
                      Swal.close();
                      resolve(true); // Continue to next prompt
                    }}
                  >
                    No, use a different card
                  </Button>
                  <Button
                    style={{
                      cursor: "pointer",
                      backgroundColor: "#3085d6",
                      color: "white",
                      border: "none",
                      fontSize: "1.12rem",
                      textTransform: "none",
                      width: "50%",
                    }}
                    onClick={async () => {
                      setName(`${card.CardholderName}`);
                      setNumber(card.MaskedAccount);
                      setExpiry(`${card.ExpDate}`);

                      const paymentResult = await processTokenPayment(
                        total,
                        card.Token,
                        card.CustomerID
                      );
                      console.log(paymentResult);

                      if (paymentResult === "Approved") {
                        Swal.close(); // Close the previous Swal

                        Swal.fire({
                          title: "Payment Approved!",
                          text: "Redirecting to the home page...",
                          icon: "success",
                          allowOutsideClick: false, // Prevent closing by clicking outside
                          showConfirmButton: false, // Hide the confirm button
                          didOpen: () => {
                            // Add a spinner
                            Swal.showLoading();
                          },
                        });

                        // Redirect after a delay
                        setTimeout(() => {
                          Swal.close(); // Close the Swal before redirecting
                          history.push("/welcome");
                        }, 2000); // Adjust the delay as needed
                      } else {
                        console.error(
                          "Payment was not approved:",
                          paymentResult
                        );
                        Swal.close();
                        // resolve(true); // Continue to next prompt
                      }
                    }}
                  >
                    Yes, use this card
                  </Button>
                </div>
              </>,
              document.getElementById("swal-buttons")
            );
          },
        });
      });

      if (!proceed) {
        break; // Stop the loop if the user chooses a card
      }
    }
  };

  // Handle payment using a saved token
  const processTokenPayment = async (amount, token, customerID) => {
    if (!amount || !token || !customerID) {
      console.error("Invalid parameters passed to processTokenPayment:", {
        token,
        amount,
        customerID,
      });
      return "Error: Invalid parameters";
    }

    const url = `${apiBaseURL}/payment/pay-using-token/${siteId}/${serverId}`;

    try {
      setLoading(true); // Set loading to true before API call
      const response = await axios.post(url, {
        token: token,
        amount: amount,
        customerID: customerID,
      });
      return response.data;
    } catch (error) {
      console.error("Error during payment processing:", error);
      return "Error: Payment failed";
    } finally {
      setLoading(false); // Set loading to false after API call completes
    }
  };

  /******************************************* */
  // Four validation functions below
  const validateNumber = (value) => {
    let error = "";
    const sanitizedValue = value.replace(/\s+/g, "");

    const luhnCheck = (num) => {
      let sum = 0;
      for (let i = 0; i < num.length; i++) {
        let intVal = parseInt(num.substr(i, 1));
        if (i % 2 === num.length % 2) {
          intVal *= 2;
          if (intVal > 9) {
            intVal -= 9;
          }
        }
        sum += intVal;
      }
      return sum % 10 === 0;
    };

    const regex = /^\d{13,19}$/;

    if (value.length === 0) {
      error = "";
    } else if (!regex.test(sanitizedValue)) {
      error = "Card number must be between 13 and 19 digits";
    } else if (!luhnCheck(sanitizedValue)) {
      error = "Card number is invalid";
    }

    if (error !== "") {
      setNumberInputStyle((prev) => ({
        ...prev,
        borderColor: "red",
      }));
    } else {
      setNumberInputStyle((prev) => ({
        ...prev,
        borderColor: "#909090",
      }));
    }

    setErrors((prevErrors) => ({ ...prevErrors, number: error }));
    return !error;
  };
  const validateName = (value) => {
    let error = "";
    const regex = /^[A-Za-z\s]+$/;

    if (value.length === 0) {
      error = "";
    } else if (value.length < 2) {
      error = "Name must be at least 2 characters";
    } else if (value.length > 50) {
      error = "Name must be less than 50 characters";
    } else if (!regex.test(value)) {
      error = "Name can only contain alphabetic characters and spaces";
    }

    if (error !== "") {
      setNameInputStyle((prev) => ({
        ...prev,
        borderColor: "red",
      }));
    } else {
      setNameInputStyle((prev) => ({
        ...prev,
        borderColor: "#909090",
      }));
    }

    setErrors((prevErrors) => ({ ...prevErrors, name: error }));
    return !error;
  };
  const validateExpiry = (value) => {
    let error = "";

    const month = parseInt(value.substring(0, 2), 10);
    const year = parseInt(value.substring(2, 4), 10);
    const currentYear = new Date().getFullYear() % 100;
    const currentMonth = new Date().getMonth() + 1;

    if (value.length === 0) {
      error = "";
    } else if (month < 1 || month > 12) {
      error = "MM must be between 01 and 12";
    } else if (
      year < currentYear ||
      (year === currentYear && month < currentMonth)
    ) {
      error = "Expiry date cannot be in the past";
    }

    if (error !== "") {
      setExpDateInputStyle((prev) => ({
        ...prev,
        borderColor: "red",
      }));
    } else {
      setExpDateInputStyle((prev) => ({
        ...prev,
        borderColor: "#909090",
      }));
    }

    setErrors((prevErrors) => ({ ...prevErrors, expiry: error }));
    return !error;
  };
  const validateCvc = (value) => {
    let error = "";
    const sanitizedValue = value.replace(/\D/g, "");
    const regex = /^\d{3,4}$/;

    if (value.length === 0) {
      error = "";
    } else if (!regex.test(sanitizedValue)) {
      error = "CVC is invalid";
    }

    if (error !== "") {
      setCvcInputStyle((prev) => ({
        ...prev,
        borderColor: "red",
      }));
    } else {
      setCvcInputStyle((prev) => ({
        ...prev,
        borderColor: "#909090",
      }));
    }

    setErrors((prevErrors) => ({ ...prevErrors, cvc: error }));
    return !error;
  };

  // Handle navigation back to payment form
  const handleGoBack = (event) => {
    event.preventDefault(); // Prevent default anchor behavior
    setSubmitted(false); // Reset submitted state
  };

  // Handle input focus for credit card fields
  const handleInputFocus = (e) => {
    setFocus(e.target.name);
  };

  // Handle input changes and validation
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const sanitizedValue = value.replace(/\D/g, ""); // Remove non-digit characters
    switch (name) {
      case "number":
        setNumber(sanitizedValue);
        validateNumber(sanitizedValue);
        break;
      case "cvc":
        setCvc(sanitizedValue);
        validateCvc(sanitizedValue);
        break;
      case "expiry":
        setExpiry(sanitizedValue);
        validateExpiry(sanitizedValue);
        break;
      case "name":
        setName(value);
        validateName(value);
        break;
      default:
        break;
    }
  };

  // Handle clicks for checkbox
  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
    console.log("checked", event.target.checked);
    if (event.target.checked === true) {
      saveUserDetails();
    }
  };

  // Save user details function
  const saveUserDetails = async () => {
    if (isSaving) return; // Prevent multiple submissions

    console.log("SAVING user data ...");

    const [firstName, ...rest] = name.split(" ");
    const lastName = rest.join(" ");
    const month = parseInt(expiry.substring(0, 2), 10);
    const year = parseInt(expiry.substring(2, 4), 10);

    const params = {
      serverId: serverId,
      siteId: siteId,
      firstName: firstName || selectedAddress?.first_name,
      lastName: lastName || selectedAddress?.last_name,
      address1:
        selectedAddress?.address.length >= 5
          ? selectedAddress?.address
          : "18W140 Butterfield Rd",
      city: selectedAddress?.city || "Oakbrook Terrace",
      state: selectedAddress?.state || "IL",
      zip: selectedAddress?.zipCode || "60181",
      cardNumber: number,
      fullName: name,
      month: month,
      year: year,
      customerNumber: customerNumber,
    };

    const url = `${apiBaseURL}/payment/save-customer-details`;

    try {
      setLoading(true); // Set loading to true before API call
      const response = await axios.post(url, params);
      const data = response.data;

      console.log(data);

      if (data.token) {
        console.log("... card data SAVED!");
      } else if (data.existingRecords) {
        console.log("card already exists ...");
        setSavedCards(data.existingRecords);
      } else if (data.error) {
        console.log(data.error);
      }
    } catch (error) {
      handleError("Error saving card details:", error);
    } finally {
      setLoading(false); // Set loading to false after API call completes
    }
  };

  // Handle Form Submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate the fields
    const isNumberValid = validateNumber(number);
    const isNameValid = validateName(name);
    const isExpiryValid = validateExpiry(expiry);
    const isCvcValid = validateCvc(cvc);

    // If any validation fails, do not proceed
    if (!isNumberValid || !isNameValid || !isExpiryValid || !isCvcValid) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        failedValidation: "Validation failed for one or more fields.",
      }));
      console.error("Validation failed for one or more fields.");
      return;
    }

    // Check if the card number is unique
    const isCardNumberUnique = !savedCards.some(
      (card) => card.MaskedAccount === number
    );

    // Create a saveUserPromise if the card is new and checkbox is checked
    const saveUserPromise =
      isChecked && isCardNumberUnique ? saveUserDetails() : Promise.resolve(); // No-op if the card is already saved or checkbox is not checked

    try {
      setIsSaving(true);
      setLoading(true); // Set loading to true before API call

      // Log message if the card is already saved and saveUserDetails is not called
      if (!isCardNumberUnique && isChecked) {
        console.log(
          "This card number is already saved. Skipping saving user details."
        );
      }

      // Promise for form submission - loading state is already set above
      const formSubmitResult = await axios.post(
        apiBaseURL + "/payment/make-payment",
        {
          cvc,
          expiry,
          name,
          number,
          isChecked,
          total,
          tax,
          deliveryCharge,
          transactionFee,
          serviceCharge,
          orderId,
          serverId,
          siteId,
          storeId,
        }
      );

      if (formSubmitResult.data !== "") {
        // Handle successful form submission response

        if (formSubmitResult.data.status === "Approved") {
          setSubmitted(true);
          Swal.fire({
            title: "Success!",
            text: "The receipt of your transaction will be sent to your email. Thank you! We appreciate you!",
            icon: "success",
            confirmButtonText: "OK",
          });
          localStorage.clear();
          sessionStorage.removeItem("order_id");
          setTimeout(() => {
            history.push(enableSL === 1 ? "/welcome" : "/menu");
          }, 3000); // Adjust timeout as necessary
        } else {
          Swal.fire({
            title: "Payment Failed!",
            text: "Please review your card information or you might consider using another card.",
            icon: "warning",
            confirmButtonText: "OK",
          });
          setSubmitted(false);
        }
      } else {
        setSubmitted(false);
        console.log("error");
      }
    } catch (error) {
      // Handle error
      console.error("There was an error making the payment request!", error);
    } finally {
      setIsSaving(false);
      setLoading(false); // Set loading to false after API call completes
    }
  };

  return (
    <div style={containerStyle}>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {submitted ? null : (
        <Box
          sx={{
            margin: 0,
            boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
            backgroundColor: "#f9f9f9",
            borderRadius:
              isSmallScreen && window.innerWidth <= 442 ? "0" : "16px",
          }}
          padding={isSmallScreen ? "24px" : "28px 32px"}
        >
          <ArrowBackSharpIcon
            onClick={() => history.goBack()}
            style={{ cursor: "pointer", marginBottom: "28px" }}
          />

          <Box
            sx={{
              display: "flex",
              gap: "36px",
              position: "relative",
            }}
            flexDirection={isSmallScreen ? "column" : "row"} // Conditional flexDirection based on screen size
          >
            <Box
              width={isSmallScreen ? "100%" : "290px"} // Responsive width
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "32px",
              }}
            >
              <Cards
                cvc={cvc}
                expiry={expiry}
                focused={focus}
                name={name}
                number={number}
              />

              <div
                style={{
                  padding: "0px 4px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    fontSize: "16px",
                    gap: "4px",
                  }}
                >
                  {/* Subtotal */}
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    Subtotal<span>${numberWithCommas(subTotal)}</span>
                  </div>
                  {/* Delivery Charge */}

                  {deliveryCharge ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      Delivery Fee
                      <span>${numberWithCommas(deliveryCharge)}</span>
                    </div>
                  ) : null}
                  {/* Service Fee */}
                  {serviceCharge ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      Service Fee<span>${numberWithCommas(serviceCharge)}</span>
                    </div>
                  ) : null}
                  {/* Tax */}
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    Tax<span>${numberWithCommas(tax)}</span>
                  </div>

                  {/* Discounts */}
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    Discounts<span>${numberWithCommas(discount)}</span>
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontSize: "18px",
                    fontWeight: "500",
                    marginTop: "4.5px",
                  }}
                >
                  Total Amount<span>${numberWithCommas(total)}</span>
                </div>
              </div>
            </Box>

            <Box
              width={isSmallScreen ? "100%" : "400px"} // Responsive width
            >
              <form onSubmit={handleSubmit}>
                {/* Card Number */}
                <div style={formDivs}>
                  <p style={labelStyle}>Card Number</p>
                  <div
                    style={{
                      position: "relative",
                    }}
                  >
                    <CreditCardSharpIcon style={iconInputStyle} />
                    <input
                      type="tel"
                      name="number"
                      placeholder="Card Number"
                      style={numberInputStyle}
                      onChange={handleInputChange}
                      onFocus={handleInputFocus}
                      value={number}
                      minLength={13}
                      maxLength={19}
                      required
                      disabled={loading} // Disable input when loading
                    />
                  </div>
                  {errors.number && (
                    <span style={errorStyle}>{errors.number}</span>
                  )}
                </div>

                {/* Expiry Date & CCV */}
                <div
                  style={{
                    display: "flex",
                    gap: "1rem",
                  }}
                >
                  <div style={{ ...formDivs, width: "65%" }}>
                    <p style={labelStyle}>Expiry Date</p>
                    <input
                      type="tel"
                      name="expiry"
                      placeholder="MMYY"
                      style={expDateInputStyle}
                      onChange={handleInputChange}
                      onFocus={handleInputFocus}
                      value={expiry}
                      minLength={4}
                      maxLength={4}
                      required
                      disabled={loading} // Disable input when loading
                    />
                    {errors.expiry && (
                      <span style={errorStyle}>{errors.expiry}</span>
                    )}
                  </div>

                  <div style={{ ...formDivs, width: "35%" }}>
                    <p style={labelStyle}>Security Code</p>
                    <div
                      style={{
                        position: "relative",
                      }}
                    >
                      <CreditCardSharpIcon style={iconInputStyle} />
                      <input
                        type="tel"
                        name="cvc"
                        placeholder="CVC"
                        style={cvcInputStyle}
                        onChange={handleInputChange}
                        onFocus={handleInputFocus}
                        value={cvc}
                        minLength={3}
                        maxLength={4}
                        required
                        disabled={loading} // Disable input when loading
                      />
                    </div>
                    {errors.cvc && <span style={errorStyle}>{errors.cvc}</span>}
                  </div>
                </div>

                {/* Name on Card */}
                <div style={formDivs}>
                  <p style={labelStyle}>Name on Card</p>
                  <input
                    type="text"
                    name="name"
                    placeholder="Name"
                    style={nameInputStyle}
                    onChange={handleInputChange}
                    onFocus={handleInputFocus}
                    value={name}
                    required
                    disabled={loading} // Disable input when loading
                  />
                  {errors.name && <span style={errorStyle}>{errors.name}</span>}
                </div>

                <div
                  style={{
                    display: showSaveCardCheckbox ? "flex" : "none",
                    alignItems: "center",
                    padding: "0 4px",
                  }}
                >
                  <input
                    type="checkbox"
                    checked={isChecked}
                    onChange={handleCheckboxChange}
                    style={checkBoxStyle}
                  />
                  <span style={{ fontSize: "16px" }}>
                    Save this card for future payments
                  </span>
                </div>

                <button
                  style={{
                    color: buttonText,
                    backgroundColor: buttonColor,
                    border: "none",
                    borderRadius: "24px",
                    cursor: loading ? "not-allowed" : "pointer", // Change cursor when loading
                    fontSize: "20px",
                    marginTop: "20px",
                    padding: "10px",
                    textTransform: "none",
                    width: "100%",
                    opacity: loading ? 0.6 : 1, // Reduce opacity when loading
                  }}
                  type="submit"
                  disabled={loading} // Disable button when loading
                >
                  {loading ? "Processing..." : "Pay now"}
                </button>
              </form>
            </Box>
          </Box>
        </Box>
      )}
    </div>
  );
};
